import React, { useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import { ThemeContext } from '..';
import { TagProps } from './types';
import { TagContainer } from './styles';

const Tag: React.FC<TagProps> = ({ status = 'default', label, testId, fullWidth = false }) => {
  const { actualTheme } = useContext(ThemeContext);
  return (
    <ThemeProvider theme={actualTheme}>
      <TagContainer data-testid={testId} status={status} fullWidth={fullWidth}>
        {label}
      </TagContainer>
    </ThemeProvider>
  );
};

export default Tag;
